const metadata = {
  id: 5,
  name: `Honoring Medical Donors and Future Healers: University of Arizona College of Medicine`,
  metadata: {
    description: `This case describes the spiritual care provided by a medical school faculty member and the  creation of a ceremony to provide spiritual guidance to future doctors who may otherwise struggle in gross anatomy with exposure to a dead body. `,
    objectives: [`understand the significance of diverse spiritualities and cultural beliefs in a medical education/professional setting.`, `consider academic curricula as culturally significant objects.`,`gain a new perspective on the provision of spiritual care to STEM students`, ],
    themes: [`Students and practitioners who are working with the topic of religious diversity`, `Anatomy students or students whose work has an anatomical component`, `Healthcare professionals who might be called upon to work with anatomy students`, `Educators, chaplains, and administrators who might be called upon to provide spiritual care to a diverse student population`],

  },
  image:
    "https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/download.webp",
  slug: "honoring-medical-donors-and-future-healers",
  title: `Honoring Medical Donors and Future Healers: University of Arizona College of Medicine`,
}

export default metadata;